import { observer } from 'mobx-react-lite'
import { useLoaderData } from 'react-router'
import { TeamsContainer } from '@/features/iam/teams/Teams/TeamsContainer'
import type { TeamsViewLoaderData } from '@/features/iam/iam-route-loaders'

export default observer(function WorkspaceTeamsContainer() {
  const data = useLoaderData<TeamsViewLoaderData>()
  return data && <TeamsContainer vm={data.vm} />
})
